import React from 'react';
import {connect} from 'react-redux';
import {Players as BasePlayers} from 'desktop/elements/players';

class Players extends BasePlayers {
    canComponentBeRendered() {
        const {lateswapCsvLineups} = this.props;

        return lateswapCsvLineups.isLoadingStatusFinished();
    }
}

function mapStatesToProps(state) {
    const {
        playersData,
        sportConfig,
        lateSwap: {csvLineups},
        playersDropzone,
    } = state;

    return {
        sportConfig,
        players: playersData.players,
        lateswapCsvLineups: csvLineups,
        playersDropzone,
    };
}

export default connect(mapStatesToProps)(Players);
